/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'slider': {
    width: 46,
    height: 46,
    viewBox: '0 0 46 46',
    data: `<defs><clipPath id="svgicon_slider_a"><path pid="0" d="M0 0h46v46H0z"/></clipPath></defs><g _fill="none" _stroke="#000" stroke-width="1.189" clip-path="url(#svgicon_slider_a)"><path pid="1" data-name="Path 139" d="M12.286 11.999L1 22.999l11.286 11"/><path pid="2" data-name="Path 140" d="M33.714 11.999l11.286 11-11.286 11"/></g>`
  }
})
/* tslint:enable */
